<script setup lang="ts">
  import SidebarIconBar from './SidebarIconBar.vue';
  import SidebarPanel from './SidebarPanel.vue';

  const emit = defineEmits(['sidebar-state']);
  const route = useRoute();

  const sidebarOpen = ref(false);
  const activeType = ref<'dashboard' | 'reports' | null>(null);
  const manualActive = ref<'tutorial' | 'linkedin' | null>(null);

  const toggleSidebar = (type: 'dashboard' | 'reports') => {
    manualActive.value = null;

    if (activeType.value === type) {
      sidebarOpen.value = !sidebarOpen.value;
    } else {
      activeType.value = type;
      sidebarOpen.value = true;
    }

    emit('sidebar-state', sidebarOpen.value);
  };

  const activeSection = computed(() => {
    // manual override for tutorial / linkedin
    if (manualActive.value) {
      return manualActive.value;
    }

    if (route.path === '/') return 'home';

    if (route.path.includes('report') || route.path.includes('export') || route.path.includes('user-vs-grants')) {
      return 'reports';
    }

    return 'dashboard';
  });

  watch(route, () => {
    manualActive.value = null;

    if (route.path === '/') {
      sidebarOpen.value = false;
      activeType.value = null;
    }
  });
</script>

<template>
  <div class="flex h-[calc(100vh-56px)] fixed z-50">
    <SidebarIconBar
      :active="activeSection"
      @tutorial="manualActive = 'tutorial'"
      @linkedin="manualActive = 'linkedin'"
      @toggle="toggleSidebar"
    />

    <SidebarPanel :open="sidebarOpen" :type="activeType" @close-sidebar="sidebarOpen = false">
      <slot />
    </SidebarPanel>
  </div>
</template>
